<template>
    <div>
        <vs-alert v-if="this.project" :active="this.project.denied" class="mb-3" icon-pack="feather" icon="icon-alert-circle" color="danger">
            {{$t("DeniedReason")}} {{this.project.denial_reason}}
        </vs-alert>

        <vs-alert v-if="project" :active="project.status > 2" class="mb-3" color="success"> {{$t("ProjectFinished")}}! </vs-alert>

        <div class="vx-row" v-if="project">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2" >
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view">

                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ project.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Client")}}</td>
                            <td>{{ $store.getters.companyClients[ project.client_company_id].name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("ProjectLeader")}}</td>
                            <td>{{ $store.getters.companyUsers[project.company_user_id].name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Finished")}}</td>
                            <td>{{ project.completed_percent }}%</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("PlannedTime")}}</td>
                            <td>{{ project.time_planned }}h</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("TimeWorked")}}</td>
                            <td>{{ project.time_worked }}h</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("OfferId")}}</td>
                            <td>{{ project.offer_id }}</td>
                        </tr>
                    </table>
                    <h6 class="mt-6">{{$t("Description")}}</h6>
                    <p style="white-space: pre-wrap" class="mt-3">{{ project.description }}</p>

                    <vs-alert :active="project.status === 1" class="mt-2" color="warning"> {{$t("ProjectWaitingForUserConfirm")}}! </vs-alert>
                    <vs-alert :active="project.status === 2" class="mt-2" color="warning"> {{$t("ProjectWaitingForClientConfirm")}}! </vs-alert>

                    <vs-button v-if="(this.$checkPermission(202) || this.$store.getters.userData.id === project.company_user_id) && project.status === 0" class="mt-3 mr-3" style="float:left;" color="warning" icon-pack="feather" icon="icon-edit" type="border" @click="editProjectPrompt = true" >{{$t("Edit")}}</vs-button>
                    <vs-button v-if="(this.$checkPermission(215) || (this.$store.getters.userData.id === project.company_user_id && this.$checkPermission(213))) && project.status === 0" class="mt-3 mr-3" style="float:left;" color="success" icon-pack="feather" icon="icon-send" type="border" :disabled="project.completed_percent !== 100 || project.offer_id.length === 0" @click="startHandoverPrompt = true" >{{$t("StartWithHandover")}}</vs-button>
                    <vs-button v-if="(this.$checkPermission(216) || (this.$store.getters.userData.id === project.company_user_id && this.$checkPermission(214))) && project.status === 0" class="mt-3 mr-3" style="float:left;" color="success" icon-pack="feather" icon="icon-lock" type="border" :disabled="project.completed_percent !== 100" @click="activeFinishNoHandoverPrompt = true" >{{$t("FinishProjectWithoutHandover")}}</vs-button>
                    <vs-button v-if="(this.$checkPermission(215) || (this.$store.getters.userData.id === project.company_user_id && this.$checkPermission(213))) && project.status > 0 && project.status < 3" class="mt-3 mr-3" style="float:left;" color="danger" icon-pack="feather" icon="icon-lock" type="border" @click="stopHandover" >{{$t("StopHandover")}}</vs-button>
                    <vs-button v-if="project.status === 3 || project.status === 5" class="mt-3 mr-3" style="float:left;" color="success" icon-pack="feather" icon="icon-download" type="border" @click="downloadHandoverPrintout" >{{$t("DownloadHandoverPrintout")}}</vs-button>
                    <div style="clear: both"/>

                    <vs-popup :title="$t('Edit')" :active.sync="editProjectPrompt">
                        <div>
                            <p class="mt-6">{{$t("Name")}}</p>
                            <vs-input v-model="projectEdit['name']" style="width: 100%"/>
                            <p class="mt-6">{{$t("OfferId")}}</p>
                            <vs-input v-model="projectEdit['offer_id']" style="width: 100%"/>
                            <p class="mt-6">{{$t("AssignedUser")}}</p>
                            <vs-select style="width: 100%" class="selectExample" v-model="projectEdit['company_user_id']">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                            </vs-select>
                            <p class="mt-6">{{$t("Description")}}</p>
                            <vs-textarea v-model="projectEdit['description']" class="w-full" />
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editProject">{{$t("Change")}}</vs-button>
                            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeProject">{{$t("Delete")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
                <vx-card v-if="this.$checkPermission(1101) && invoice !== undefined && project.status > 2" :title="(invoice.length > 0) ? $t('Invoice') + ' - ' + invoice : $t('Invoice')" class="mb-base" >

                    <p v-if="project.status === 4 || project.status === 6" class="mb-3">{{this.$t('ProjectFinishedWithoutHandover')}}</p>

                    <vs-button v-if="this.$checkPermission(1101) && invoice.length > 0" class="mt-3 mr-3" style="float:left;" color="success" icon-pack="feather" icon="icon-download" type="border" @click="downloadInvoice" >{{$t("Download")}}</vs-button>
                    <vs-button v-if="this.$checkPermission(1102) && invoice.length === 0 && project.status < 5" class="mt-3 mr-3" style="float:left;" color="warning" icon-pack="feather" icon="icon-file" type="border" @click="addInvoicePrompt = true" >{{$t("Add")}}</vs-button>
                    <vs-button v-if="this.$checkPermission(1102) && invoice.length > 0 && project.status < 5" class="mt-3 mr-3" style="float:left;" color="warning" icon-pack="feather" icon="icon-file" type="border" @click="addInvoicePrompt = true" >{{$t("Change")}}</vs-button>
                    <div style="clear: both"/>

                    <vs-popup :title="$t('Edit')" :active.sync="addInvoicePrompt">
                        <div>
                            <vs-upload v-if="this.$checkPermission(1102)" :text="$t('UploadFile')" :automatic="true" limit="1" fileName="file" :action="'/api/v1/project/' + this.$route.params.id + '/invoice/'" @on-success="updateInvoiceFile" />
                        </div>
                    </vs-popup>

                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-2/3 lg:w-1/2 md:w-1/2">
                <project-files-table :id="Number(this.$route.params.id)" :status="project.status" :editable="this.$checkPermission(202) || this.$store.getters.userData.id === project.company_user_id" :type="0"/>
            </div>
        </div>

        <div id="ag-grid-demo">
            <vx-card :title="$t('Tasks')">

                <!-- TABLE ACTION ROW -->
                <div class="flex flex-wrap justify-between items-center">

                    <!-- ITEMS PER PAGE -->
                    <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                        <vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ gridApi.getDisplayedRowCount() - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : gridApi.getDisplayedRowCount() }} of {{ gridApi.getDisplayedRowCount() }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>

                            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                    <span>150</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <div style="float:right;" v-if="project">
                            <vs-button v-if="(this.$checkPermission(202) || this.$store.getters.userData.id === project.company_user_id) && project.status === 0" class="ml-6 mt-1" type="border" color="success" @click="activeNewTaskPrompt = true" >{{$t("Add")}}</vs-button>
                        </div>

                    </div>


                    <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                    <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                        <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                        <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
                        <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
                    </div>
                </div>

                <ag-grid-vue
                        ref="agGridTable"
                        :gridOptions="gridOptions"
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef"
                        :rowData="tasks"
                        rowSelection="multiple"
                        colResizeDefault="shift"
                        domLayout="autoHeight"
                        :animateRows="true"
                        :floatingFilter="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true">
                </ag-grid-vue>
                <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage" />

            </vx-card>
            <router-view>
            </router-view>

            <vs-popup :title="$t('Add')" :active.sync="activeNewTaskPrompt" style="z-index: 54000">
                <vx-card>
                    <vs-row vs-w="12" vs-justify="space-around">
                        <vs-col vs-w="6" vs-sm="12">
                            <p>{{$t("TaskTitle")}}</p>
                            <vs-input v-model="taskAddTitle"/>
                            <p class="mt-6">{{$t("HourNumber")}}</p>
                            <vs-input v-model="taskAddProjectHours"/>
                            <p class="mt-6">{{$t("BranchOffice")}}</p>
                            <vs-select autocomplete class="selectExample" v-model="taskAddBranchOffice">
                                <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                            </vs-select>
                        </vs-col>
                        <vs-col vs-w="6" vs-sm="12">
                            <p class="mt-6">{{$t("Tags")}}</p>
                            <v-select class="selectStyle" multiple :options="selectableTags" label="name" v-model="taskAddTags">
                                <template slot="option" slot-scope="option">
                                    <div style="display: flex">
                                        <vs-chip :color="option.color" style="margin: auto" class="mt-1">
                                            <p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
                                        </vs-chip>
                                    </div>
                                </template>
                            </v-select>
                            <p class="mt-6">{{$t("Priority")}}</p>
                            <vs-select autocomplete class="selectExample" v-model="taskAddPriority">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
                            </vs-select>
                            <p class="mt-6">{{$t("Deadline")}}</p>
                            <flat-pickr :config="configDateTimePicker" v-model="taskAddDeadline"/>
                        </vs-col>
                    </vs-row>

                    <p class="mt-6">{{$t("Description")}}</p>
                    <vs-textarea v-model="taskAddDescription" class="w-full" />
                    <vs-divider/>
                    <vs-button color="success" class="mt-6; mr-1" @click="addTask">{{$t("Add")}}</vs-button>
                </vx-card>

            </vs-popup>

            <vs-popup :title="$t('StartWithHandover')" :active.sync="startHandoverPrompt" style="z-index: 54000">
                <div>
                    <vs-select autocomplete class="selectExample" v-model="selectedContact">
                        <vs-select-item :key="index" :value="item.id" :text="item.name + ' ' + item.l_name" v-for="(item,index) in clientContacts" />
                    </vs-select>
                    <vs-divider/>
                    <vs-button :disabled="this.selectedContact.length === 0" color="success" type="border" class="mt-6; mr-1" @click="startHandover">{{$t("Start")}}</vs-button>
                </div>
            </vs-popup>

            <vs-prompt
                    @accept="finishWithoutHandover"
                    style="z-index: 54000"
                    :title="$t('FinishProjectWithoutHandover')"
                    :active.sync="activeFinishNoHandoverPrompt">
                {{$t("FinishNoHandoverPrompt")}}
            </vs-prompt>

        </div>
    </div>
</template>
<script>

    import { AgGridVue } from "ag-grid-vue"
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import PriorityRenderer from "../Task/PriorityRenderer";
    import StatusRenderer from "../Task/StatusRenderer";

    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import Task from "../Task";
    import PriorityEditor from "../Task/PriorityEditor";
    import AssignedUserEditor from "../Task/AssignedUserEditor";
    import TimeRenderer from "../Task/TimeRenderer";
    import DeadlineRenderer from "../Task/DeadlineRenderer";
    import ProjectFilesTable from "./ProjectFilesTable";
    import ProjectTimeWorkedRenderer from "../Task/ProjectTimeWorkedRenderer";
    import vSelect from 'vue-select'

    export default {
        components: {
            ProjectFilesTable,
            Task,
            AgGridVue,
            flatPickr,
            PriorityRenderer,
            StatusRenderer,
            PriorityEditor,
            AssignedUserEditor,
            TimeRenderer,
            DeadlineRenderer,
            ProjectTimeWorkedRenderer,
            'v-select': vSelect,
        },
        data() {
            return {
                project: undefined,
                projectEdit: undefined,

                editProjectPrompt: false,

                activeFinishNoHandoverPrompt: false,

                invoice: undefined,
                addInvoicePrompt: false,

                clientContacts: [],
                selectedContact: '',
                startHandoverPrompt: false,

                activeNewTaskPrompt: false,
                taskAddTitle: '',
                taskAddClient: '',
                taskAddBranchOffice: '',
                taskAddPriority: '',
                taskAddProjectHours: '',
                taskAddDeadline: null,
                taskAddDescription: '',
                taskAddTags: [],

                projectClient: null,

                branchOffices: [{}],
                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
                selectedTaskId: 0,
                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        if (e.column.colId === 'title' || e.column.colId === 'client_company_id') {
                            this.selectedTaskId = e.data.id;
                            this.$router.push({ name: 'task', params: { id: "" + this.selectedTaskId } })
                        }
                    },
                    onCellValueChanged: (e) => {
                        if (e.column.colId === 'priority') {
                            this.changeTaskPriority(e.data.id, e.data.priority);
                        }else if (e.column.colId === 'company_user_id') {
                            if(e.data.company_user_id === 0) return;
                            this.assignTask(e.data.id, e.data.company_user_id);
                        }else if (e.column.colId === 'project_hours') {
                            if(this.$store.getters.userData.id !== this.project.company_user_id && !this.$checkPermission(202)) return;
                            this.changeTaskProjectHours(e.data.id, e.data.project_hours);
                        }
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns(['client_company_id', 'project_hours', 'total_time_worked', 'title', 'company_user_id', 'status', 'priority', 'added_time', 'deadline']);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                    }
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [
                    {
                        headerName: "ID",
                        field: 'company_task_id',
                        filter: true,
                        width: 50
                    },
                    {
                        headerName: this.$t("Client"),
                        field: 'client_company_id',
                        filter: true,
                        valueGetter: this.companyValueGetter
                    },
                    {
                        headerName: this.$t("TaskTitle"),
                        field: 'title',
                        filter: true,
                    },
                    {
                        headerName: this.$t("HourNumber"),
                        field: 'project_hours',
                        filter: true,
                        editable: true,
                    },
                    {
                        headerName: this.$t("TimeWorked"),
                        field: 'total_time_worked',
                        filter: true,
                        cellRendererFramework: ProjectTimeWorkedRenderer,
                    },
                    {
                        headerName: this.$t("Status"),
                        field: 'status',
                        filter: true,
                        valueGetter: this.statusValueGetter,
                        cellRendererFramework: StatusRenderer,
                    },
                    {
                        headerName: this.$t("Priority"),
                        field: 'priority',
                        filter: true,
                        editable: true,
                        cellRendererFramework: PriorityRenderer,
                        cellEditorFramework: PriorityEditor,
                        cellStyle: {'background-color': 'rgb(0,0,0,0)'}
                    },
                    {
                        headerName: this.$t("AssignedUser"),
                        field: 'company_user_id',
                        filter: true,
                        editable: true,
                        valueGetter: this.userValueGetter,
                        cellEditorFramework: AssignedUserEditor,
                        cellStyle: {'background-color': 'rgb(0,0,0,0)'}
                    },
                    {
                        headerName: this.$t("Added"),
                        field: 'added_time',
                        filter: true,
                        cellRendererFramework: TimeRenderer,
                    },
                    {
                        headerName: this.$t("Deadline"),
                        field: 'deadline',
                        filter: true,
                        cellRendererFramework: DeadlineRenderer,
                    },
                ],
                tasks: []
            }
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(['client_company_id', 'project_hours', 'total_time_worked', 'title', 'company_user_id', 'status', 'priority', 'added_time', 'deadline']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateProject() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.project = response.data;
                        thisIns.projectEdit = JSON.parse(JSON.stringify(response.data));
                        thisIns.$http.get('/api/v1/client/' + thisIns.project.client_company_id + "/branch_offices")
                            .then(function (response) {
                                thisIns.branchOffices = response.data;
                                thisIns.taskAddBranchOffice = thisIns.branchOffices[0].id
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                        thisIns.$http.get('/api/v1/client/' + thisIns.project.client_company_id + "/contacts/")
                            .then(function (response) {
                                thisIns.clientContacts = response.data
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    position:'top-right',
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });

                        thisIns.$http.get('/api/v1/client/' + thisIns.project.client_company_id)
                            .then(function (response) {
                                thisIns.projectClient = response.data;
                            })
                            .catch(function (error) {
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.updateInvoiceFile()
            },
            updateInvoiceFile() {
                this.addInvoicePrompt = false;
                const thisIns = this;
                if(this.$checkPermission(1101)) {
                    thisIns.$http.get('/api/v1/project/' + this.$route.params.id + "/invoice/")
                        .then(function (response) {
                            thisIns.invoice = response.data
                        })
                        .catch(function (error) {
                            thisIns.$vs.notify({
                                title:'Error',
                                text: error,
                                position:'top-right',
                                color:'danger',
                                iconPack: 'feather',
                                icon:'icon-alert-circle'})
                        });
                }
            },
            downloadInvoice(){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                    window.location.href = '/api/v1/project/' + this.$route.params.id + "/invoice/download";
                }else{
                    window.open('/api/v1/project/' + this.$route.params.id + "/invoice/download");
                }
            },
            downloadHandoverPrintout(){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                    window.location.href = '/api/v1/project/' + this.$route.params.id + "/handover/download";
                }else{
                    window.open('/api/v1/project/' + this.$route.params.id + "/handover/download");
                }
            },
            startHandover() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id + "/handover/start/" + this.selectedContact)
                    .then(function () {
                        thisIns.startHandoverPrompt = false;
                        thisIns.updateProject();
                    }).catch(function (error) {
                    thisIns.startHandoverPrompt = false;
                    thisIns.updateProject();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            stopHandover() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id + "/handover/stop/")
                    .then(function () {
                        thisIns.updateProject();
                    }).catch(function (error) {
                    thisIns.updateProject();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            finishWithoutHandover() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id + "/finish/no_handover/")
                    .then(function () {
                        thisIns.updateProject();
                    }).catch(function (error) {
                    thisIns.updateProject();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editProject() {
                const thisIns = this;
                this.$http.put('/api/v1/project/' + this.$route.params.id, this.projectEdit)
                    .then(function () {
                        thisIns.updateProject();
                        thisIns.editProjectPrompt = false;
                    }).catch(function (error) {
                    thisIns.editProjectPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeProject() {
                const thisIns = this;
                this.$http.delete('/api/v1/project/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editProjectPrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/projects')
                        });

                    }).catch(function (error) {
                    thisIns.editProjectPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id + "/task")
                    .then(function (response) {
                        thisIns.tasks = response.data
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addTask() {
                const thisIns = this;
                this.$http.post('/api/v1/task/', {
                    title: thisIns.taskAddTitle,
                    description: thisIns.taskAddDescription,
                    deadline: thisIns.moment(thisIns.taskAddDeadline).format(),
                    priority: thisIns.taskAddPriority,
                    client_company_id: Number(thisIns.project['client_company_id']),
                    project_hours: Number(thisIns.taskAddProjectHours),
                    project: Number(thisIns.$route.params.id),
                    branch_office_id: Number(thisIns.taskAddBranchOffice),
                    tags: thisIns.taskAddTags
                }).then(function () {
                    thisIns.updateTasks();
                    thisIns.activeNewTaskPrompt = false;

                    thisIns.taskAddTitle = "";
                    thisIns.taskAddDescription = "";
                }).catch(function (error) {
                    thisIns.activeNewTaskPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            changeTaskPriority(taskId, priority){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + taskId + "/priority/" + priority)
                    .then(function () {
                        thisIns.updateTasks()
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            changeTaskProjectHours(taskId, hours){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + taskId + "/projectHours/", {
                        project_hours: Number(hours)
                    })
                    .then(function () {
                        thisIns.updateTasks()
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            assignTask(taskId, userId){
                const thisIns = this;
                this.$http.put('/api/v1/task/' + taskId + "/assign/" + userId)
                    .then(function () {
                        thisIns.updateTasks()
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            companyValueGetter(param){
                if(this.$store.getters.companyClients[param.data.client_company_id] === undefined) return "";
                return this.$store.getters.companyClients[param.data.client_company_id].name
            },
            userValueGetter(param){
                if(this.$store.getters.companyUsers[param.data.company_user_id] === undefined || param.data.company_user_id === 0) return "";
                return this.$store.getters.companyUsers[param.data.company_user_id].name
            },
            statusValueGetter(param) {
                switch (param.data.status) {
                    case 0:
                        return this.$t("Unassigned");
                    case 1:
                        return this.$t("Open");
                    case 2:
                        return this.$t("InProgress");
                    case 3:
                        return this.$t("Waiting");
                    case 4:
                        return this.$t("SentForConfirmation");
                    case 5:
                        return this.$t("Confirmed");
                    case 6:
                        return this.$t("Invoiced");
                    default:
                        return ""

                }
            }
        },
        computed: {
            selectableTags() {

                let tags = [];



                for (let key in this.$store.state.tags) {
                    if (this.$store.state.tags.hasOwnProperty(key)){
                        if(this.$store.state.tags[key].global){
                            tags.push(this.$store.state.tags[key])
                        }
                    }
                }

                if(this.projectClient){

                    for(let x = 0; x < this.projectClient.tags.length; x++) {
                        if(!tags.includes(this.projectClient.tags[x])){
                            tags.push(this.projectClient.tags[x]);
                        }
                    }
                }

                return tags;

            },
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                for(let x = 0; x < state.length; x++){
                    total += state[x].width
                }
                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
            this.updateTasks();
        },
        created() {
            this.updateProject();
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
